// Nyckeln läggs in som den är (inte URL-kodad). Testvyn för kartnycklar (pages/Tests/TestMapsApiKey)
// bygger samma adress härifrån så att den prövar nyckeln precis som de riktiga kartorna.
export const buildMapsUrl = (apiKey: string) =>
  `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=quarterly`;

export const loadMapApi = (apiKey: string) => {
  const mapsURL = buildMapsUrl(apiKey);
  const scripts = document.getElementsByTagName('script');
  // Go through existing script tags, and return google maps api tag when found.
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src.indexOf(mapsURL) === 0) {
      return scripts[i];
    }
  }

  const googleMapScript = document.createElement('script');
  googleMapScript.src = mapsURL;
  googleMapScript.async = true;
  googleMapScript.defer = true;
  window.document.body.appendChild(googleMapScript);

  return googleMapScript;
};
